module.exports = "/_next/static/images/a50cf8a08bdc73b5a769d1362a6e938c-man-sitting-with-notebook@lg-2x.jpg.webp";